module.exports = __webpack_public_path__ + "img/photo-0102.1a40db6d.jpg";